export default __webpack_public_path__ + "static/media/Singing national anthem.0171983f.JPG";